import { VisualFile } from '@/types/visual_file';

export interface Profile {
  profile_id: number,
  name: string,
  description: string,
  visuals: VisualFile[],
  uniqueid: string,
  instagram?: string,
  tiktok?: string,
  snapchat?: string,
  facebook?: string,
  x?: string,
  website?: string,
}

export const UNKNOWN_PROFILE : Profile = {
  profile_id: -1,
  name: "Unknown",
  description: "Unknown",
  visuals: [],
  uniqueid: "unknown",
};
